import React from 'react';
import { ReactComponent as SmsIcon } from '../../../../../assets/icons/sms.svg';
import { useHasPermission } from '../../../../../services/auth/auth';
import { capText, timestampToHuman } from '../../../../../services/formatting';
import { useParams } from '../../../../../services/routing/useRouteInfo';
import { ViewLayout } from '../../../../shared/cardLayouts/viewLayout';
import { AutoSizeCard } from '../../../../shared/cards/autoSizeCard';
import { IconHeading } from '../../../../shared/cards/iconHeading';
import { StatCard } from '../../../../shared/cards/statCard';
import { UserPopoutCard } from '../../../../shared/cards/userPopoutCard';
import { LoadText } from '../../../../shared/load/loadText';
import { View } from '../../../../shared/view/view';

import styles from './campaignAdhocView.module.css';
import { pathJoin } from '../../../../../services/api';
import { Link } from 'react-router-dom';
import { CAMPAIGN_ADHOC, CAMPAIGN_ADHOC_TEMPLATE, USER } from '../../../../../permissions';


export const CampaignAdhocView = () => {

    let { id } = useParams();
    const canReadUser = useHasPermission([USER.READ]);
    const canReadTemplate = useHasPermission([CAMPAIGN_ADHOC_TEMPLATE.READ]);

    return <View
        id={parseInt(id ?? '')}
        resourceName='Campaign'
        nameFunction={r => capText(r?.reason, 30)}
        restEndpoint='/communications/campaigns/adhocs'
        listUrl='/communications/campaigns'
        readPermissions={[CAMPAIGN_ADHOC.READ]}
        writePermissions={[CAMPAIGN_ADHOC.WRITE]}
        actions={[]}
    >
        {
            ({ loading, data, canWrite, canRead, refreshData }) => <ViewLayout>
                <StatCard
                    title={<>Campaign Info</>}
                    stats={{
                        'Reason': loading ? <LoadText /> : data.reason ?? 'None',
                        'Channel': loading ? <LoadText /> : data.channel.displayName ?? 'None',
                        'Template': loading ? <LoadText /> : data.template 
                            ? canReadTemplate
                                ? <Link to={pathJoin('/communications/campaigns/templates', data.template.id)}>{data.template.name}</Link>
                                : data.template.name
                            : 'None',
                        'Outbound Contact': loading ? <LoadText /> :  (data.template?.outboundCallerId && data.template.outboundCallerId.name + ' ' + data.template.outboundCallerId.contact) ?? 'None',
                        'Date': loading ? <LoadText /> : timestampToHuman(data.createDate) ?? 'None',
                        'Contact Count': loading ? <LoadText /> : data.contactCount,
                    }}
                />

                <AutoSizeCard
                    columns={2}
                >
                    <IconHeading icon={<SmsIcon />} iconBackground={false}>
                        Message
                    </IconHeading>
                    <div className={styles.Message}>{loading ? <><LoadText /><br /><LoadText /><br /><LoadText /></> : data.template?.message}</div>
                </AutoSizeCard>

                <UserPopoutCard
                    data={{
                        displayName: loading ? <LoadText /> : data.createBy?.displayName ?? 'None',
                        id: data.createBy?.id
                    }}
                    subtitle='Created By'
                    action={canReadUser ? undefined : <></>}
                />
            </ViewLayout>
        }
    </View>
}